import React from "react";
import "./components.css";

function Footer() {
  const date = new Date();
  const year = date.getFullYear();

  return (
    <footer className="grid-bg-colour fixed-bottom" style={{ paddingTop: 10 }}>
      <div className="container">
        <p className="m-0 text-center text-white">
          Copyright &copy; HQ Software {year}, v0.018
        </p>
      </div>
    </footer>
  );
}

export default Footer;
